<template>
  <div :class="['$attrs.class']">
    <div class="tw-flex">
      <div class="tw-uppercase tw-text-lg tw-mb-3 tw-font-bold">
       <span class="tw-font-black">{{guestsFed}} / {{totalGuestsToFeed}}</span> Guests Fed
      </div>
      <div class="tw-text-lg tw-ml-auto">
        <router-link :to="{ name: 'wizard-step', params: { step: 2}}">edit</router-link>
      </div>
    </div>
    <div>
      <ProgressBar 
        :height="'small'"
        :percentage="percentageAccountedFor"
       />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed } from 'vue'
  import type CateringOrder from '../../types/CateringOrder';
  import type {PropType} from 'vue';

  import ProgressBar from '../../components/ProgressBar.vue'

  const props = defineProps({
    cateringOrder: {
      type: (Object as PropType<CateringOrder>),
      default: null,
    },
    guestsFed: {
      type: Number,
      default: 0,
    }
  })

  const totalGuestsToFeed = computed(() => {
    let total = 0
    if (props.cateringOrder) {
      total += props.cateringOrder.guest_count
      // total += props.cateringOrder.light_eaters 
      // total += props.cateringOrder.regular_eaters
      // total += props.cateringOrder.hungry_eaters;
    }
    return total;
  })

  const percentageAccountedFor = computed(() => {
    const total = totalGuestsToFeed.value;
    if (total > 0 && props.guestsFed > 0) {
      return Math.min(100, ((props.guestsFed/total) * 100));
    } else {
      return 0;
    }
  })

</script>
